// extracted by mini-css-extract-plugin
export default {"warning":"s0lw7"};